import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux'
import allActions from '../../actions'
import { unoTheme } from '../../assets/styles/unoTheme';
import { applyMaskAmount, applyMaskAccount, applyMaskAmountFreeDecimals, checkIsSameBalance, checkIsSameQuotas } from './utils'

import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({

    alertBalance: {
        '& .MuiAlert-message': {
            fontSize: '12px',
            padding: '0px',
            '& span': {
                verticalAlign: 'middle',
            }
        },
        '& .MuiAlert-icon': {
            padding: '0px',
        },
        '& .alertMain': {
            marginTop: '5px',
            marginBottom: '5px',
        }
    },
    bold: {
        color: 'black',
    },
    green: {
        color: unoTheme.greenMoney
    },
    red: {
        color: unoTheme.errorColor,
    },
    blue: {
        color: 'blue',
    },
}));

/**
 * Retorna o JSX do alerta de cota especial para uso tanto no componente
 * quanto em contextos externos (ex: modal de conciliação geral).
 * @param {Object} row - linha de dados
 * @param {Function|null} action - callback chamado ao atualizar cota (null oculta o botão)
 * @param {string} role - papel do usuário
 * @returns {JSX.Element}
 */
export function getAlertSpecialClientQuotaContent(row, action, role) {
    const canAct = action && (role == "ROLE_ADMIN" || role == "ROLE_SUPER_ADMIN" || role == 'ROLE_ADVISOR');

    return (
        <Alert
            className={'alertMain'}
            variant="outlined"
            severity="info"
            action={
                canAct
                    ? <Button color={"inherit"} size="small" onClick={() => action(row.balance_now_id)}>
                        {'ATUALIZAR COTA'}
                    </Button>
                    : null
            }>
            <span><span style={{ color: 'black' }}>Cota do cliente não informada</span></span>
            <br />
            <span>Considere atualizar cota específica do mês para esse ativo</span>
        </Alert>
    );
}

/**
 * My main alert
 * @param {string} show 
 * @param {string} type
 * @param {string} message
 * @returns {Object} Alert
 */
export default function MyAlertSpecialClientQuota(props) {

    const classes = useStyles();

    const { row, action, role } = props

    return (
        <div className={classes.alertBalance}>
            {getAlertSpecialClientQuotaContent(row, action, role)}
        </div>
    );
}